import { Injectable } from '@angular/core';

@Injectable()
export class LookupListService
{
    constructor()
    {
    }

    get climateLogicTypes(): { Text: string, Value: string }[]
    {
        return [
            { Text: 'Climate Logic Wireless Receiver', Value: '1' },
            { Text: 'Climate Logic Mini-Receiver', Value: '4' },
        ];
    }

    defaultActiveAuxiliariesList(): { Text: string, Value: string }[]
    {
        return [
            { Text: '1', Value: '1' },
            { Text: '2', Value: '2' },
            { Text: '3', Value: '3' },
        ];
    }

    defaultActiveScheduleList(): { Text: string, Value: string }[]
    {
        return [
            { Text: 'A', Value: '1' },
            { Text: 'B', Value: '2' },
            { Text: 'C', Value: '3' },
            { Text: 'D', Value: '4' },
            { Text: 'E', Value: '5' },
            { Text: 'F', Value: '6' },
            { Text: 'G', Value: '7' },
            { Text: 'H', Value: '8' },
        ];
    }

    static getStateAbbreviation(state: string)
    {
        switch (state)
        {
            case 'Alabama':
                return 'AL';
            case 'Alaska':
                return 'AK';
            case 'Arizona':
                return 'AZ';
            case 'Arkansas':
                return 'AR';
            case 'California':
                return 'CA';
            case 'Colorado':
                return 'CO';
            case 'Connecticut':
                return 'CT';
            case 'Delaware':
                return 'DE';
            case 'Florida':
                return 'FL';
            case 'Georgia':
                return 'GA';
            case 'Hawaii':
                return 'HI';
            case 'Idaho':
                return 'ID';
            case 'Illinois':
                return 'IL';
            case 'Indiana':
                return 'IN';
            case 'Iowa':
                return 'IA';
            case 'Kansas':
                return 'KS';
            case 'Kentucky':
                return 'KY';
            case 'Louisiana':
                return 'LA';
            case 'Maine':
                return 'ME';
            case 'Maryland':
                return 'MD';
            case 'Massachusetts':
                return 'MA';
            case 'Michigan':
                return 'MI';
            case 'Minnesota':
                return 'MN';
            case 'Mississippi':
                return 'MS';
            case 'Missouri':
                return 'MO';
            case 'Montana':
                return 'MT';
            case 'Nebraska':
                return 'NE';
            case 'Nevada':
                return 'NV';
            case 'New Hampshire':
                return 'NH';
            case 'New Jersey':
                return 'NJ';
            case 'New Mexico':
                return 'NM';
            case 'New York':
                return 'NY';
            case 'North Carolina':
                return 'NC';
            case 'North Dakota':
                return 'ND';
            case 'Ohio':
                return 'OH';
            case 'Oklahoma':
                return 'OK';
            case 'Oregon':
                return 'OR';
            case 'Pennsylvania':
                return 'PA';
            case 'Rhode Island':
                return 'RI';
            case 'South Carolina':
                return 'SC';
            case 'South Dakota':
                return 'SD';
            case 'Tennessee':
                return 'TN';
            case 'Texas':
                return 'TX';
            case 'Utah':
                return 'UT';
            case 'Vermont':
                return 'VT';
            case 'Virginia':
                return 'VA';
            case 'Washington':
                return 'WA';
            case 'Washington, D.C.':
                return 'DC';
            case 'West Virginia':
                return 'WV';
            case 'Wisconsin':
                return 'WI';
            case 'Wyoming':
                return 'WY';
            case 'Alberta':
                return 'AB';
            case 'British Columbia':
                return 'BC';
            case 'Manitoba':
                return 'MB';
            case 'New Brunswick':
                return 'NB';
            case 'Newfoundland and Labrador':
                return 'NL';
            case 'Northwest Territories':
                return 'NT';
            case 'Nova Scotia':
                return 'NS';
            case 'Nunavut':
                return 'NU';
            case 'Ontario':
                return 'ON';
            case 'Prince Edward Island':
                return 'PE';
            case 'Quebec':
                return 'QC';
            case 'Saskatchewan':
                return 'SK';
            case 'Yukon':
                return 'YT';
            default:
                return state;
        }
    }

    static getStatesList(): string[]
    {
        return ['Alabama',
            'Alaska',
            'Arizona',
            'Arkansas',
            'California',
            'Colorado',
            'Connecticut',
            'Delaware',
            'Florida',
            'Georgia',
            'Hawaii',
            'Idaho',
            'Illinois',
            'Indiana',
            'Iowa',
            'Kansas',
            'Kentucky',
            'Louisiana',
            'Maine',
            'Maryland',
            'Massachusetts',
            'Michigan',
            'Minnesota',
            'Mississippi',
            'Missouri',
            'Montana',
            'Nebraska',
            'Nevada',
            'New Hampshire',
            'New Jersey',
            'New Mexico',
            'New York',
            'North Carolina',
            'North Dakota',
            'Ohio',
            'Oklahoma',
            'Oregon',
            'Pennsylvania',
            'Rhode Island',
            'South Carolina',
            'South Dakota',
            'Tennessee',
            'Texas',
            'Utah',
            'Vermont',
            'Virginia',
            'Washington',
            'Washington, D.C.',
            'West Virginia',
            'Wisconsin',
            'Wyoming'];
    }

    static getProvincesList(): string[]
    {
        return ['Alberta',
            'British Columbia',
            'Manitoba',
            'New Brunswick',
            'Newfoundland and Labrador',
            'Northwest Territories',
            'Nova Scotia',
            'Nunavut',
            'Ontario',
            'Prince Edward Island',
            'Quebec',
            'Saskatchewan',
            'Yukon'];
    }

    static getCountriesList(): string[]
    {
        return [
            'United States',
            'Canada',
            'Afghanistan',
            'Albania',
            'Algeria',
            'Andorra',
            'Angola',
            'Antigua and Barbuda',
            'Argentina',
            'Armenia',
            'Australia',
            'Austria',
            'Azerbaijan',
            'Bahamas',
            'Bahrain',
            'Bangladesh',
            'Barbados',
            'Belarus',
            'Belgium',
            'Belize',
            'Benin',
            'Bhutan',
            'Bolivia',
            'Bosnia and Herzegovina',
            'Botswana',
            'Brazil',
            'Brunei',
            'Bulgaria',
            'Burkina Faso',
            'Burundi',
            'Cambodia',
            'Cameroon',
            'Canada',
            'Cape Verde',
            'Central African Republic',
            'Chad',
            'Chile',
            'China',
            'Colombia',
            'Comoros',
            'Costa Rica',
            'Croatia',
            'Cuba',
            'Cyprus',
            'Czech Republic',
            'Democratic Republic of the Congo',
            'Denmark',
            'Djibouti',
            'Dominica',
            'Dominican Republic',
            'East Timor',
            'Ecuador',
            'Egypt',
            'El Salvador',
            'Equatorial Guinea',
            'Eritrea',
            'Estonia',
            'Ethiopia',
            'Fiji',
            'Finland',
            'France',
            'Gabon',
            'Gambia',
            'Georgia',
            'Germany',
            'Ghana',
            'Greece',
            'Grenada',
            'Guatemala',
            'Guinea',
            'Guinea-Bissau',
            'Guyana',
            'Haiti',
            'Honduras',
            'Hungary',
            'Iceland',
            'India',
            'Indonesia',
            'Iran',
            'Iraq',
            'Ireland',
            'Israel',
            'Italy',
            'Ivory Coast',
            'Jamaica',
            'Japan',
            'Jordan',
            'Kazakhstan',
            'Kenya',
            'Kiribati',
            'Kuwait',
            'Kyrgyzstan',
            'Laos',
            'Latvia',
            'Lebanon',
            'Lesotho',
            'Liberia',
            'Libya',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Madagascar',
            'Malawi',
            'Malaysia',
            'Maldives',
            'Mali',
            'Malta',
            'Marshall Islands',
            'Mauritania',
            'Mauritius',
            'Mexico',
            'Micronesia',
            'Moldova',
            'Monaco',
            'Mongolia',
            'Montenegro',
            'Morocco',
            'Mozambique',
            'Myanmar',
            'Namibia',
            'Nauru',
            'Nepal',
            'Netherlands',
            'New Zealand',
            'Nicaragua',
            'Niger',
            'Nigeria',
            'North Korea',
            'Norway',
            'Oman',
            'Pakistan',
            'Palau',
            'Palestine',
            'Panama',
            'Papua New Guinea',
            'Paraguay',
            'Peru',
            'Philippines',
            'Poland',
            'Portugal',
            'Qatar',
            'Republic of Macedonia',
            'Republic of the Congo',
            'Romania',
            'Russia',
            'Rwanda',
            'Saint Kitts and Nevis',
            'Saint Lucia',
            'Saint Vincent and the Grenadines',
            'Samoa',
            'San Marino',
            'Sao Tome and Principe',
            'Saudi Arabia',
            'Senegal',
            'Serbia',
            'Seychelles',
            'Sierra Leone',
            'Singapore',
            'Slovakia',
            'Slovenia',
            'Solomon Islands',
            'Somalia',
            'South Africa',
            'South Korea',
            'South Sudan',
            'Spain',
            'Sri Lanka',
            'Sudan',
            'Suriname',
            'Swaziland',
            'Sweden',
            'Switzerland',
            'Syria',
            'Tajikistan',
            'Tanzania',
            'Thailand',
            'Togo',
            'Tonga',
            'Trinidad and Tobago',
            'Tunisia',
            'Turkey',
            'Turkmenistan',
            'Tuvalu',
            'Uganda',
            'Ukraine',
            'United Arab Emirates',
            'United Kingdom',
            'United States',
            'Uruguay',
            'Uzbekistan',
            'Vanuatu',
            'Vatican City',
            'Venezuela',
            'Vietnam',
            'Yemen',
            'Zambia',
            'Zimbabwe'
        ];
    }
}
